export default __webpack_public_path__ + "static/media/logo.229667a1.svg";